export default function Log(ENV) {
    const fn = this;

    fn.baseStyle = ["display: block", "text-align: right"];

    fn.enabled = false;

    fn.construct = function () {
        fn.enabled = ENV.enableLog;
    };

    /**
     *
     * @param {string} title
     * @param {obj} obj
     * @param {string} color // versionThemes
     */
    fn.endpoint = function (title, string, theme) {
        if (!fn.enabled) {
            return false;
        }

        const styles = fn.versionThemes(theme);

        console.debug("%c %s %s", fn.mixinStyles(styles), title, string);
        // console.trace();
    };

    fn.obj = function (title, obj, theme) {
        if (!fn.enabled) {
            return false;
        }

        const styles = fn.versionThemes(theme);

        console.debug("%c %s %o", fn.mixinStyles(styles), title, obj);
        // console.trace();
    };

    fn.string = function (title, string, theme) {
        if (!fn.enabled) {
            return false;
        }

        const styles = fn.versionThemes(theme);

        return console.debug("%c %s %s", fn.mixinStyles(styles), title, string);
        // console.trace();
    };

    fn.mixinStyles = function (styles) {
        return [...fn.baseStyle, ...styles].join(";");
    };

    fn.versionThemes = function (theme) {
        switch (theme) {
            case "info":
                return ["background:purple", "color:white;"];

            case "APIv3":
                return ["background:#292C35", "color:lightblue"];

            case "legacy":
                return ["background:#292C35", "color:#00c1d5"];

            case "endpoint":
                return ["background:#292C35", "color:black;"];

            case "basket-info":
                return ["background:#deff00", "color:black;"];

            case "basket-resolve":
                return ["background:#01d69f", "color:black;"];

            case "basket-rejection":
                return ["background:#f16f38", "color:black;"];

            case "periods":
                return ["background:#292C35", "color:00c1d5;"];

            case "highlight":
                return ["background:#deff00", "color:black;"];

            default:
                return [];
        }
    };

    fn.construct();

    return fn;
}
